import Datagrid from "./datagrid/Datagrid.vue";
import DeleteListingItem from "./basic/DeleteListingItem.vue";
import BatchActionForm from "./BatchActionForm.vue";
import BatchActionDocumentsForm from "./BatchActionDocumentsForm.vue";

Vue.component('datagrid', Datagrid);
Vue.component('delete-listing-item', DeleteListingItem);
Vue.component('batch-action-form', BatchActionForm);
Vue.component('batch-action-documents-form', BatchActionDocumentsForm);



// WEBPACK FOOTER //
// ./resources/assets/admin/js/components/index.js